import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { EncryptStorage } from 'encrypt-storage';
export const encryptStorage = new EncryptStorage(toString('wfsl2024'), {
  storageType: 'localStorage',
  stateManagementUse: true
});

export default createStore({
  state: {
    user: null,
    email: null,
    currentRole: null,
    semester_schoolyear: null,
    access: null,
  },
  getters: {
  },
  mutations: {
    UPDATE_USER(state, payload){
      state.user = payload
    },
    UPDATE_EMAIL(state, payload){
      state.email = payload
    },
    UPDATE_ROLE(state, payload){
      state.currentRole = payload
    },
    UPDATE_SEMESTER_SCHOOLYEAR(state, payload){
      state.semester_schoolyear = payload
    },
    UPDATE_ACCESS(state, payload){
      state.access = payload
    }
  },
  actions: {
   
  },
  modules: {
  },
  plugins: [createPersistedState({ 
    storage: { 
      setItem: (key, state) => encryptStorage.setItem(key, state),
      getItem: (key) => encryptStorage.getItem(key),
      removeItem: (key) => encryptStorage.removeItem(key)
    }
  })],
})
